export const LOADING_FB_PAGES = 'fb_pages/LOAD_FB_PAGES'
export const LOADING_FB_PAGES_SUCCESS = 'fb_pages/LOAD_FB_PAGES_SUCCESS'
export const LOADING_FB_PAGES_FAILURE = 'fb_pages/LOAD_FB_PAGES_FAILURE'
export const ADD_FOUND_FB_PAGE = 'fb_pages/ADD_FOUND_FB_PAGE'
